import { StarIcon } from '@chakra-ui/icons';
import SadIcon from '../../../../images/sadicon2.png';
import {
  Avatar,
  Box,
  Button,
  chakra,
  Flex,
  HStack,
  VStack,
  Heading,
  Text,
  Td,
  Badge,
  useDisclosure,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  useToast,
  Spinner,
  Icon,
  TableContainer,
  Table,
  Tr,
  TabPanel,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  Tbody,
  Skeleton,
} from '@chakra-ui/react';
import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Loading from '../../../Loading';
import { AccountContext } from '../../../AccountContext';
import BottomNavBar from '../../../BottomNavBar';
import ChildHeader from '../ChildHeader';
import PopupDependenteSemCpf from './PopupDependenteSemCpf';
import SelectField from 'components/SelectField';
import SelectFieldId from 'components/SelectFieldId';
import { Formik } from 'formik';
import '../../css/lista-datas.css';
import NoUserHeader from 'components/AreaLivre/NoUserHeader';
import DrawerCompraPlano from '../DrawerCompraPlano';
import DrawerServico from '../DrawerServico';
import _ from 'lodash';
import LoadingGenerico from '../Telemedicina/Especialista/LoadingGenerico';
import ModalRestricaoSexo from '../Exames/ModalRestricaoSexo';
import { api } from 'api/api';
import Empresa from 'images/dashboard/empresa.svg';
import Procedimento from 'images/dashboard/Procedimento.svg';
import Paciente from 'images/dashboard/visitante.png';
import { IoMdCalendar } from 'react-icons/io';
import { userIsSubscriber } from 'components/Utils/theme';
const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function Agendamento() {
  const navigate = useNavigate();
  const { user, setPage, setUser, toastInadimplente } = useContext(AccountContext);
  const [dependentes, setDependentes] = useState([]);
  const arrayNomeDependentes =
    user.loggedIn && dependentes.length > 0
      ? dependentes.map((dependente) => ({ id: dependente.paciente_contrato_dependente_id, label: dependente.nome }))
      : [];

  //dados do medico
  const { state } = useLocation();
  const {
    medico,
    startNum,
    st,
    defaultDateTime,
    procedimento,
    price,
    procedimentoId,
    procedimentoParticular,
    valorParticular,
    avaliacao,
    restricao_sexo,
  } = state;
  console.log(state);
  const newState = { ...state };
  const [updatedState, setUpdatedState] = useState(newState);

  const [empresaSelecionada, setEmpresaSelecionada] = useState(medico.dados.empresa);
  // return;
  const arrName = medico.dados.nome.split(' ');
  // Seleciona o primeiro paciente e procedimento como padrão caso não haja seleção
  const [pag, setPag] = useState(startNum ?? 0);
  const [pac, setPac] = useState(st ?? 0);
  const [procedimentoSelecionadoId, setProcedimentoSelecionadoId] = useState(null);
  const [escolha, setEscolha] = useState(null);
  const [disabled, setDisabled] = useState(false);
  const [agendas, setAgendas] = useState([]);
  const uniqueDates = [...new Set(agendas.map((day) => day.AVA_DATE))];
  const [loaded, setLoaded] = useState(false);
  //const avaliacao = Math.round(medico.dados.avaliacao_media);
  const disclosure = useDisclosure();
  const scheduleDrawer = useDisclosure();
  const [isLoading, setIsLoading] = useState(true);
  const [priceData, setPriceData] = useState(procedimento);
  const [checkingAvailability, setCheckingAvailability] = useState(false);
  const loading = useDisclosure();
  const [reload, setReload] = useState(false);
  const toast = useToast();
  const [pickWarning, setPickWarning] = useState(false);
  let faixa_inicial = 0;
  let faixa_final = 0;
  const restricaoSexo = useDisclosure();
  // Removido daqui, agora está acima para garantir inicialização correta

  const faixa_etaria = agendas?.map((faixas, index) => {
    if (faixas.faixa_etaria !== 0 || faixas.faixa_etaria_final !== 0) {
      faixa_inicial = faixas.faixa_etaria;
      faixa_final = faixas.faixa_etaria_final;
    }
  });

  let data_parcela = '';
  if (user.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();

  let titulo = '';
  if (medico.dados.sexo === 'M') {
    titulo = 'Dr. ';
  } else if (medico.dados.sexo === 'F') {
    titulo = 'Dra. ';
  }

  setPage('Agendamento');

  const assinante = userIsSubscriber(user);

  const [idClientClinica, setIdClientCinica] = useState(0);
  const getClinicasId = async (cpf) => {
    const url = ENDPOINT + '/clients/getClientByCpfClinica/' + cpf;
    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const postsData = await response.json();
    if (postsData.length > 0) {
      setIdClientCinica(postsData[0].paciente_id);
      setReload(true);
    } else {
      setIdClientCinica(null);
    }
  };

  useEffect(() => {
    getClinicasId(user.username);
  }, [user.username]);

  const fetchPosts = async () => {
    if (!procedimentoId || isNaN(procedimentoId)) {
      //quando não tinha procedimento e pesquisava, dava erro
      setAgendas([]);
      setPickWarning(false);
      setIsLoading(false);
      return;
    }
    const procedimentoIdSelecionado = procedimentoSelecionadoId ? procedimentoSelecionadoId : procedimentoId;
    const url =
      ENDPOINT +
      '/schedule/getAvailability/' +
      medico.dados.medico +
      '/' +
      procedimentoIdSelecionado +
      '/' +
      id_cliente +
      '?agendaEspecialidade=false';
    const response = await api(url, {
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      method: 'GET',
    });
    const postsData = await response.json();

    setAgendas(postsData);
    setPickWarning(false);
    setIsLoading(false);
  };
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;
  const id_cliente = user.loggedIn ? (idClientClinica !== null ? idClientClinica : user.id_cliente_deovita) : 0;
  let pacienteId = id_cliente;
  const handlePick = async (agendaId, medico, agenda, filteredAgenda, filteredAgendasOrdemChegada, index) => {
    try {
      loading.onOpen();
      if (!idClientClinica) {
        const postsData = await api(`${ENDPOINT}/clients/post_client_clinicas`, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ cpf: user.username }),
        });

        const response = await postsData.json();

        if (response.paciente_id === 0) {
          toast({
            title: 'Importante',
            description: 'Não foi possível realizar a operação. Entre em contato com o suporte',
            status: 'warning',
            duration: 4000,
            isClosable: true,
            position: 'top',
            colorScheme: 'red',
            containerStyle: {
              paddingTop: '50px',
            },
          });
          return;
        }
        pacienteId = response.paciente_id;
      }

      const url = ENDPOINT + '/schedule/checkAvailability/' + agendaId + '/' + pacienteId;
      const response = await api(url, {
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        method: 'GET',
      });
      const postsData = await response.json().then(({ available }) => {
        if (available === true) {
          document.getElementById('agenda' + index).scrollIntoView({ behavior: 'smooth' });
          document.querySelectorAll(`[class="chakra-badge css-raqg5x"]`).forEach((item) => {
            item.style.border = 'none';
          });
          document.getElementById('agenda' + index).scrollIntoView({ inline: 'center', behavior: 'smooth' });
          document.getElementById('agenda' + index).style.border = '2px solid #5AB2AE';

          setEscolha({
            medicoNome: titulo + tratarNome(medico?.dados?.nome || medico?.nome),
            tipo: medico.dados.tipo,
            especialidade: medico.dados.especialidade,
            valor:
              (user.id_contrato > 0 || (user.loggedIn === true && user.titular === false)) && !clientePendente
                ? updatedState.price
                : updatedState.valorParticular,
            agenda: filteredAgenda,
            paciente: dependentes[pac],
            clinica: medico.dados.empresa,
            logradouro: medico.dados.logradouro,
            numero: medico.dados.numero,
            bairro: medico.dados.bairro,
            municipio: medico.dados.municipio,
            medico: medico,
            procedimentoSelecionadoId: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).id,
            procedimento: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).label || null,
            procedimento_id: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).id,
          });
          if (escolha) {
            setUser((prevState) => ({ ...prevState, pedido_pendente: { ...escolha, agenda: escolha.agenda } }));
          }
          //lockAgenda(filteredAgenda.AVAILABILITY_LID);
          //socket.emit('unlockSchedule', '');
          //socket.emit('lockSchedule', filteredAgenda.AVAILABILITY_LID);
          loading.onClose();
          dependentes[pac].cpf && setDisabled(true);
        } else {
          loading.onClose();
          setPickWarning(true);
        }
      });
    } catch (error) {}
  };
  let contador = 0;
  useEffect(() => {
    setIsLoading(true);

    const fetchDependentes = async () => {
      const url2 = ENDPOINT + '/client/dependents2';
      const titularId = {
        id_contrato: user.id_contrato,
        idade_inicial: faixa_inicial ? faixa_inicial : 0,
        idade_final: faixa_final ? faixa_final : 0,
        username: user.cpf,
      };
      const response = await api(url2, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(titularId),
      });
      const resp = await response.json();
      console.log(contador ++ + ' dependentes');
      if (resp.data[0] !== null) {
        return resp.data;
      } else {
        return [{ nome: user.name, paciente_id: user.id_cliente_deovita, ...user }];
      }
    };

    const fetchAll = async () => {
      const [dependentesData] = await Promise.all([
        fetchDependentes(),
        fetchPosts(),
      ]);
      setDependentes(dependentesData);
      if (user.loggedIn && clientePendente) {
        toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
      }
      setIsLoading(false);
    };
    fetchAll();
  }, [reload, id_cliente]);

  useEffect(() => {
    const agendaEscolhida = agendas.find((i) => uniqueDates?.[pag] === i.AVA_DATE);
    if (agendaEscolhida) {
      newState.price = agendaEscolhida.PRICE;
      newState.valorParticular = agendaEscolhida.valor_particular;
      setUpdatedState(newState);
    }
  }, [agendas]);

  function escolhaData(uniqueDate) {
    const agendaEscolhida = agendas.find((i) => uniqueDate === i.AVA_DATE);
    if (agendaEscolhida) {
      newState.price = agendaEscolhida.PRICE;
      newState.valorParticular = agendaEscolhida.valor_particular;
      setUpdatedState(newState);
    }
  }

  const diasSemana = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];

  const filteredAgendasOrdemChegada = agendas.filter((i) => uniqueDates?.[pag]?.includes(i.AVA_DATE) && i.ordem_chegada === true);
  let horario_chegada = filteredAgendasOrdemChegada.filter(
    (item, index, self) => index === self.findIndex((i) => i.AVA_START_TIME === item.AVA_START_TIME),
  );

  const filteredAgendas = agendas.filter((i) => uniqueDates?.[pag]?.includes(i.AVA_DATE) && i.ordem_chegada === false);

  const mapDates = uniqueDates.map((uniqueDate, index) => {
    const event = new Date(uniqueDate.split('/').reverse().join('-') + 'T08:00:00');

    const dia = String(event.getDate()).padStart(2, '0');
    const mes = String(event.getMonth() + 1).padStart(2, '0');
    const semana = diasSemana[event.getDay()];

    const isSelected = pag === index;

    return (
      <Td key={uniqueDate} p={0}>
        <Box
          px={2}
          py={2}
          mx={0}
          maxW="150px"
          borderRadius="16px"
          cursor="pointer"
          bg="white"
          border="1px solid"
          borderColor={isSelected ? '#5AB2AE' : '#E0E0E0'}
          onClick={() => {
            document.getElementById(`date-box-${index}`)?.scrollIntoView({ behavior: 'smooth', inline: 'center' });
            setPag(index);
            setDisabled(false);
            escolhaData(uniqueDate);
          }}
        >
          <HStack spacing={1}>
            <Box bg="#E1F1F1" borderRadius="10px" px={2} py={1} minW="48px" textAlign="center">
              <Text fontWeight="bold" fontSize="sm" color="#5AB2AE">
                {dia}/{mes}
              </Text>
            </Box>

            <Text fontSize="sm" fontWeight="500" color="#616161" textTransform="lowercase">
              {semana}
            </Text>
          </HStack>
        </Box>
      </Td>
    );
  });

  let agenda = '';
  function filterAllAgendas(array, ordem) {
    if (ordem) {
      agenda = filteredAgendasOrdemChegada.filter((item, index, self) => index === self.findIndex((i) => i.AVA_START_TIME === item.AVA_START_TIME));
      // setPriceData(1);
    } else {
      agenda = agendas.filter((i) => uniqueDates?.[pag]?.includes(i.AVA_DATE) && i.ordem_chegada === false);
    }
    return agenda;
  }

  if (filteredAgendasOrdemChegada.length > 0) {
    filterAllAgendas(horario_chegada, true);
  } else {
    filterAllAgendas(filteredAgendas, false);
  }
  const [agendaSelecionadaId, setAgendaSelecionadaId] = useState(null);

  const useFilteredAgendas = agenda.map((filteredAgenda, index) => {
    const dateTime = `${filteredAgenda.AVA_DATE} ${filteredAgenda.AVA_START_TIME}`;
    const isSelected = agendaSelecionadaId === filteredAgenda.AVAILABILITY_LID || dateTime === defaultDateTime;

    return (
      <Td key={filteredAgenda.AVAILABILITY_LID}>
        <Badge
          id={'agenda' + index}
          borderRadius="0.5em"
          margin="0 0.5em"
          padding="0.5em 1.4em"
          size="lg"
          border="1px solid #5AB2AE"
          fontSize={filteredAgendasOrdemChegada.length > 0 ? 'sm' : 'md'}
          style={isSelected ? { border: '2px solid #5AB2AE' } : {}}
          backgroundColor="white"
          color="#5AB2AE"
          onClick={() => {
            setAgendaSelecionadaId(filteredAgenda.AVAILABILITY_LID);

            handlePick(filteredAgenda.AVAILABILITY_LID, medico, agenda, filteredAgenda, filteredAgendasOrdemChegada, index);

            setEscolha({
              medicoNome: titulo + tratarNome(medico?.dados?.nome || medico?.nome),
              tipo: medico.dados.tipo,
              especialidade: medico.dados.especialidade,
              valor:
                (user.id_contrato > 0 || (user.loggedIn === true && user.titular === false)) &&
                (!user.qntdeParcelas?.countParcelas || user.qntdeParcelas?.countParcelas === 0 || user.qntdeParcelas?.countParcelas === '0')
                  ? updatedState.price
                  : updatedState.valorParticular,
              agenda: filteredAgenda,
              paciente: dependentes[pac],
              clinica: medico.dados.empresa,
              logradouro: medico.dados.logradouro,
              numero: medico.dados.numero,
              bairro: medico.dados.bairro,
              municipio: medico.dados.municipio,
              medico,
              procedimentoSelecionadoId: procedimentoSelecionadoId,
              procedimento: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId)?.label || null,
              procedimento_id: procedimentoSelecionadoId,
              procedimentoId: procedimentoSelecionadoId,
            });

            setDisabled(true);
          }}
        >
          {filteredAgendasOrdemChegada.length > 0 ? `A partir de ${filteredAgenda.AVA_START_TIME}` : filteredAgenda.AVA_START_TIME}
        </Badge>
      </Td>
    );
  });

  const confirmEstimate = (id) => {
    if (id > 0) {
      const postData = api(`${ENDPOINT}/cart/estimate/${id}/confirm`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        if (res.status === 200) {
          let newCartItems = _.filter(user.solicitacoes, (item) => !_.includes([id], item.ambulatorio_orcamento_id));
          if (newCartItems.length === 0) {
            setUser((prevState) => ({ ...prevState, solicitacoes: {} }));
          } else {
            setUser((prevState) => ({ ...prevState, solicitacoes: { ...newCartItems } }));
          }
        }
      });
    }
  };

  /*const renderAvaliacao = (avaliacao_media) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          color={avaliacao_media >= i || avaliacao_media === 0 || avaliacao_media === '0' || !avaliacao_media ? 'orange' : 'gray.500'}
        />
      );
    }
    return stars;
  }; */

  async function validaSexoProcedimento(sexo) {
    const validacao_sexo1 = restricao_sexo ? restricao_sexo : null;
    if (!validacao_sexo1) {
      if (escolha?.medico?.horarios) {
        for (let horario of escolha.medico.horarios) {
          let procedimentoEncontrado = horario.procedimentos.find((proc) => proc.id === procedimentoId);
          if (
            !procedimentoEncontrado ||
            procedimentoEncontrado.restricao_sexo === '' ||
            procedimentoEncontrado.restricao_sexo === null ||
            procedimentoEncontrado.restricao_sexo === 'A' ||
            procedimentoEncontrado.restricao_sexo === sexo
          ) {
            return true;
          }
          if (
            !procedimentoEncontrado ||
            procedimentoEncontrado.restricao_sexo === '' ||
            procedimentoEncontrado.restricao_sexo === null ||
            procedimentoEncontrado.restricao_sexo === 'A' ||
            procedimentoEncontrado.restricao_sexo === sexo
          ) {
            return true;
          }
          return false;
        }
      }
      return true;
    }
    if (validacao_sexo1 === sexo || !validacao_sexo1 || validacao_sexo1 === '' || validacao_sexo1 === null || validacao_sexo1 === 'A') {
      return true;
    }
    return false;
  }

  const renderAvaliacao = (avaliacao_media) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          color={avaliacao_media >= i || avaliacao_media === 0 || avaliacao_media === '0' || !avaliacao_media ? 'orange' : 'gray.500'}
        />,
      );
    }
    return stars;
  };

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState('5.0');
    const [isLoading, setIsLoading] = useState(true);
    const formatarAvaliacao = (media) => {
      const valor = Math.floor(media * 10) / 10;
      return valor.toFixed(1);
    };

    useEffect(() => {
      if (avaliacao) {
        const valor = !avaliacao.avaliacao_media || avaliacao.avaliacao_media === '0' ? 5 : Number(avaliacao.avaliacao_media);

        setAvaliacaoMedia(formatarAvaliacao(valor));
        setIsLoading(false);
      }
    }, [avaliacao]);

    return (
      <HStack spacing={1} align="center">
        <StarIcon color="orange" fontSize="1em" />
        <chakra.span fontSize="0.75em" color="orange" fontWeight={500}>
          {isLoading ? <Spinner size="sm" color="#5ab2ae" /> : avaliacaoMedia}
        </chakra.span>
      </HStack>
    );
  };

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';

    const primeiroNome = capitalizar(partes[0]);

    if (partes.length === 1) return primeiroNome;

    const segundoNome = capitalizar(partes[1]);

    return `${primeiroNome} ${segundoNome}`;
  };

  const toCamelCase = (text = '') =>
    text
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

  const horarios = medico.horarios;

  const [opcoesProcedimentos, setOpcoesProcedimentos] = useState([]);

  const sexo = user?.loggedIn ? (user.sexo?.toUpperCase() === 'M' ? 'M' : user.sexo?.toUpperCase() === 'F' ? 'F' : null) : null;

  useEffect(() => {
    if (!horarios?.length) return;
    const map = new Map();
    horarios.forEach((horario) => {
      horario?.procedimentos?.forEach((procedimento) => {
        const permitido =
          !user?.loggedIn ||
          !user?.sexo ||
          procedimento?.restricao_sexo === sexo ||
          procedimento?.restricao_sexo === 'A' ||
          procedimento?.restricao_sexo == null;
        if (permitido && procedimento?.nome) {
          map.set(procedimento.id, {
            id: procedimento.id,
            label: procedimento.nome,
            deovita: procedimento.valor,
            particular: procedimento?.procedimento_particular?.valor ?? null,
          });
        }
      });
    });

    const opcoes = Array.from(map.values());
    setOpcoesProcedimentos(opcoes);
    if (opcoes.length > 0 && procedimentoSelecionadoId == null) {
      setProcedimentoSelecionadoId(opcoes[0].id);
    }
  }, [horarios, sexo, user?.loggedIn]);

  useEffect(() => {
    if (procedimentoSelecionadoId) {
      fetchPosts();
    }
  }, [procedimentoSelecionadoId]);

  useEffect(() => {
    if (!horarios?.length) return;

    const map = new Map();

    horarios.forEach((horario) => {
      horario?.procedimentos?.forEach((procedimento) => {
        const permitido =
          !user?.loggedIn ||
          !user?.sexo ||
          procedimento?.restricao_sexo === sexo ||
          procedimento?.restricao_sexo === 'A' ||
          procedimento?.restricao_sexo == null;

        if (!permitido || !procedimento?.nome) return;

        const key = `${procedimento.id}-${procedimento.nome}`;

        if (!map.has(key)) {
          map.set(key, {
            id: procedimento.id,
            label: procedimento.nome,
            deovita: procedimento.valor,
            particular: procedimento?.procedimento_particular?.valor ?? null,
          });
        }
      });
    });

    const opcoes = Array.from(map.values());

    setOpcoesProcedimentos(opcoes);

    if (opcoes.length > 0 && procedimentoSelecionadoId == null) {
      setProcedimentoSelecionadoId(opcoes[0].id);
    }
  }, [horarios, sexo, user?.loggedIn]);

  const valor_cobrado = useMemo(() => {
    const proc = opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId);

    if (!proc) return 0;

    return assinante ? proc.deovita : proc.particular;
  }, [opcoesProcedimentos, procedimentoSelecionadoId, assinante]);
  const avaliacao_state = avaliacao.find((avaliacao) => avaliacao.operador_id === medico.dados.medico_id);

  if (isLoading || dependentes.length === 0 || agendas.length === 0) {
    return (
      <>
        {user.loggedIn === true ? <ChildHeader /> : <NoUserHeader />}
        <VStack w={{ base: '100%', md: '400px' }} m="10% auto" justify="center" spacing={6}>
          <Skeleton height="56px" width="56px" borderRadius="lg" />
          <Skeleton height="24px" width="60%" borderRadius="md" />
          <Skeleton height="20px" width="40%" borderRadius="md" />
          <Skeleton height="32px" width="80%" borderRadius="md" />
          <Skeleton height="48px" width="90%" borderRadius="md" />
          <Box w="100%" mt={4}>
            <Skeleton height="28px" width="30%" borderRadius="md" mb={2} />
            <HStack spacing={3} justify="center">
              <Skeleton height="36px" width="80px" borderRadius="lg" />
              <Skeleton height="36px" width="80px" borderRadius="lg" />
              <Skeleton height="36px" width="80px" borderRadius="lg" />
            </HStack>
          </Box>
        </VStack>
      </>
    );
  }
  const opcoesUnicas = Array.from(new Map(opcoesProcedimentos.map((p) => [`${p.id}-${p.ambulatorio_tipo_consulta_id}`, p])).values());
  console.log(opcoesUnicas);
  return agendas.length > 0 ? (
    <>
      {user.loggedIn === true ? <ChildHeader /> : <NoUserHeader />}
      {user.loggedIn === true ? <PopupDependenteSemCpf disclosure={disclosure} datas={dependentes[pac]} /> : null}
      <Modal isOpen={pickWarning} isCentered>
        <ModalOverlay />
        <ModalContent height="250px" width="300px" border-radius="1em">
          <ModalHeader></ModalHeader>

          <ModalBody>
            <VStack>
              <Heading size="md" textAlign="center" pl="5" pr="5" mt="15">
                Opa! O horário escolhido não está mais disponível.
              </Heading>
              <Stack direction="row" ml="-4" pt="1em" spacing={5} align="center">
                <Button
                  id="id_agd_continuar"
                  backgroundColor={assinante ? '#5AB2AE' : '#5AB2AE'}
                  color="#FFF"
                  variant="solid"
                  size="lg"
                  onClick={() => {
                    setReload(!reload);
                  }}
                >
                  continuar
                </Button>
              </Stack>
            </VStack>
          </ModalBody>

          <VStack ml="4"></VStack>
        </ModalContent>
      </Modal>
      <DrawerCompraPlano disclosure={disclosure} />
      <DrawerServico disclosure={scheduleDrawer} />
      <LoadingGenerico disclosure={loading} />
      <ModalRestricaoSexo disclosure={restricaoSexo} />
      <Formik initialValues={{ empresa: 0, dependente: 0 }} validateOnChange={false} validateOnBlur={false}>
        <Flex align="center" borderRadius="2em" p={3} w="100%" flexWrap="wrap" overflow="hidden" justify="center" textAlign="center" mb={20}>
          <Box align="center" w="100%" justify="center" spacing={2}>
            <Skeleton isLoaded={!isLoading} borderRadius="lg" width="56px" height="56px" mr={4} mt={2} mb={{ base: 3, sm: 0 }}>
              <Avatar
                src={
                  medico?.foto || medico?.dados?.foto
                    ? medico?.foto || medico?.dados?.foto
                    : process.env.REACT_APP_URL_PROFILEPICS_OPERADOR + '/' + medico.dados.medico + '/foto_profissional.png'
                }
                name={tratarNome(medico?.dados?.nome || medico?.nome) || 'Médico'}
                alt={tratarNome(medico?.dados?.nome || medico?.nome)}
                boxSize="56px"
                color="white"
                onClick={() => navigate('/empresa/medico/curriculo', { state: { medico, avaliacao: avaliacao_state } })}
                fontSize="0.75rem"
                bg="#5AB2AE"
                borderRadius="lg"
              />
            </Skeleton>

            <Text fontWeight="bold" fontSize="md" color="#616161" isTruncated maxW="100%" mt={2} mb={2}>
              {titulo} {tratarNome(medico?.dados?.nome || medico?.nome)}
            </Text>

            <HStack spacing={2} flexWrap="wrap" justify="center" alignItems="center">
              <Text fontSize="md" color="#757575" noOfLines={2} maxW="180px" wordBreak="break-word" fontWeight="bold">
                {toCamelCase(medico?.dados?.especialidade) || toCamelCase(medico?.especialidade)}
              </Text>

              <Text fontSize="sm" color="#818181" noOfLines={2} maxW="180px" wordBreak="break-word">
                {medico?.dados?.conselho && medico?.dados?.conselho}
                {medico?.dados?.conselho && medico?.dados?.rqe && ' '}
                {medico?.dados?.rqe && medico?.dados?.rqe}
              </Text>

              <HStack spacing={1} alignItems="center">
                <AvaliacaoEstrela avaliacao={avaliacao_state} />
              </HStack>
            </HStack>
          </Box>

          <Box w="100%" mt="1em" mb="1em" boxShadow="lg" p="1em" borderRadius="15px">
            <SelectField
              name="empresa"
              placeholder="Empresa"
              w="100%"
              colorScheme="teal"
              border="green"
              borderRadius="15px"
              borderWidth="2px"
              variant="ghost"
              fontWeight="bold"
              color="#757575"
              options={[medico.dados.empresa]}
              onChange={(value) => setEmpresaSelecionada(value)}
              image={Empresa}
            />

            {empresaSelecionada && (
              <Box mt={2} w="100%" textAlign="center">
                <chakra.p fontSize="sm" color="#9E9E9E">
                  {toCamelCase(medico.dados.logradouro)}, {toCamelCase(medico.dados.numero)}
                  <br />
                  {toCamelCase(medico.dados.bairro)} – {toCamelCase(medico.dados.municipio)}
                </chakra.p>
              </Box>
            )}
          </Box>

          <Box w="100%" mt="1em" mb="1em" boxShadow={'lg'} p="1em" borderRadius="15px">
            <SelectFieldId
              name="procedimento"
              textButton="Procedimento"
              w="100%"
              colorScheme="teal"
              border="green"
              borderRadius="15px"
              borderWidth="2px"
              variant="ghost"
              fontWeight="bold"
              color="#757575"
              options={opcoesUnicas}
              value={procedimentoSelecionadoId ?? (opcoesUnicas.length > 0 ? opcoesUnicas[0].id : undefined)}
              image={Procedimento}
              onChangeId={(id) => setProcedimentoSelecionadoId(id)}
            />
            <Box mt={2} w="100%" textAlign="center">
              <chakra.p fontSize="sm" color="#9E9E9E">
                {typeof procedimentoSelecionadoId !== 'undefined' && opcoesProcedimentos[procedimentoSelecionadoId]
                  ? toCamelCase(opcoesProcedimentos[procedimentoSelecionadoId].label)
                  : ''}
              </chakra.p>
            </Box>
            {typeof procedimentoSelecionadoId === 'number' && opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId) && (
              <Box mt={2} w="100%" textAlign="center">
                <HStack justifyContent="space-between" w="100%" maxW={350}>
                  <Text color="#757575" maxInlineSize={250}>
                    {toCamelCase(opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId)?.label)}
                  </Text>
                  <Text color="#5AB2AE" fontWeight={'bold'}>
                    {Number(valor_cobrado || 0).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </Text>
                </HStack>
              </Box>
            )}

            {!assinante || user.id_plano !== 29 ? (
              <Box mt={2} w="100%" textAlign="center" background="linear-gradient(90deg, #E1F1F1 0%, #B5DDDC 100%)" borderRadius="15px" p="1em">
                <chakra.p fontSize="sm" color="#616161">
                  💡 <strong>Dica:</strong> Com Assinatura Saúde Total, você economiza ainda mais em cada consulta!
                </chakra.p>
              </Box>
            ) : null}
          </Box>
          {dependentes.length > 0 && (
            <>
              <Box w="100%" mt="1em" mb="1em" boxShadow={'lg'} p="1em" borderRadius="15px">
                <SelectFieldId
                  id="id_agd_paciente"
                  name="dependente"
                  textButton="Paciente"
                  w="100%"
                  colorScheme="teal"
                  border="green"
                  borderRadius="15px"
                  borderWidth="2px"
                  variant="ghost"
                  fontWeight="bold"
                  color="#757575"
                  options={arrayNomeDependentes}
                  value={dependentes[pac]?.paciente_contrato_dependente_id ?? null}
                  onChangeId={(selectedId) => {
                    const idx = dependentes.findIndex((dep) => dep.paciente_contrato_dependente_id === selectedId);

                    if (idx === -1) return;

                    setPac(idx);
                    setEscolha((prev) => (prev ? { ...prev, paciente: dependentes[idx] } : null));

                    if (dependentes[idx]?.cpf) {
                      getClinicasId(dependentes[idx].cpf);
                      setDisabled(true);
                    } else {
                      setDisabled(false);
                      navigate('/cadastro');
                    }
                  }}
                  image={Paciente}
                />

                <Box mt={2} w="100%" textAlign="center">
                  <chakra.p fontSize="sm" color="#9E9E9E">
                    {dependentes[pac] ? tratarNome(dependentes[pac].nome) : ''}
                  </chakra.p>
                </Box>
              </Box>
            </>
          )}

          <Box w="100%" mt="1em" mb="1em" boxShadow={'lg'} p="1em" borderRadius="15px">
            <HStack textAlign="center" spacing={3} justify="center">
              <Icon as={IoMdCalendar} boxSize={5} flexShrink={0} color="#5AB2AE" />

              <Text fontWeight="bold" color="#757575">
                Selecione a data e o horário
              </Text>
            </HStack>
            {filteredAgendasOrdemChegada?.length > 0 ? (
              <Tabs variant="enclosed" w="100%">
                <TabList w="100%">
                  {filteredAgendas?.length > 0 ? <Tab w="50%">Hora Marcada</Tab> : <></>}
                  <Tab w="50%">Ordem de Chegada</Tab>
                </TabList>
                <TabPanels>
                  <TabPanel>
                    <TableContainer minWidth="100%">
                      <Table
                        variant="simple"
                        size="lg"
                        class="table-agendamento"
                        sx={{
                          borderCollapse: 'separate',
                          borderSpacing: '0px',
                        }}
                      >
                        <Tr>{mapDates}</Tr>
                      </Table>
                    </TableContainer>
                    <TableContainer minWidth="100%">
                      <Table variant="simple">
                        <Tr>{useFilteredAgendas}</Tr>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel>
                    <TableContainer minWidth="100%">
                      <Table variant="simple" size="lg" class="table-agendamento">
                        <Tr mt={3} mb={3}>
                          {mapDates}
                        </Tr>
                      </Table>
                    </TableContainer>
                    <TableContainer minWidth="100%">
                      <Table variant="simple">
                        <Tr w="100%">
                          <Td w="100%">
                            <TableContainer minWidth="100%">
                              <Table variant="simple">
                                <Tr>{useFilteredAgendas}</Tr>
                              </Table>
                            </TableContainer>
                          </Td>
                        </Tr>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                </TabPanels>
              </Tabs>
            ) : (
              <>
                <TableContainer minWidth="100%" mt={3} mb={3}>
                  <Table
                    variant="simple"
                    size="lg"
                    sx={{
                      borderCollapse: 'separate',
                      borderSpacing: '10px',
                    }}
                  >
                    <Tbody>
                      <Tr>{mapDates}</Tr>
                    </Tbody>
                  </Table>
                </TableContainer>

                <TableContainer minWidth="100%">
                  <Table variant="simple">
                    <Tr>{useFilteredAgendas}</Tr>
                  </Table>
                </TableContainer>
              </>
            )}
            <Flex justify="flex-end" mt={6}>
              <Button
                width="auto"
                minW="200px"
                backgroundColor={'#5AB2AE'}
                borderRadius="1em"
                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 4, sm: 5 }} />}
                onClick={async () => {
                  if (
                    user.qntdeParcelas?.countParcelas &&
                    user.qntdeParcelas?.countParcelas > 0 &&
                    dataAtual >= data_parcela &&
                    !updatedState?.valorParticular
                  ) {
                    toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
                    return;
                  }
                  if (user.loggedIn === true) {
                    const sexo = (dependentes && dependentes[pac]?.sexo?.toUpperCase()) || null;
                    if (sexo) {
                      const validacao = await validaSexoProcedimento(sexo);
                      if (!validacao) {
                        restricaoSexo.onOpen();
                        return;
                      }
                    }

                    if (state.orcamento_id) {
                      confirmEstimate(state.orcamento_id);
                    }

                    let states = {
                      ...escolha,
                      paciente: dependentes ? dependentes[pac] : null,
                      pacienteId: (dependentes && dependentes[pac]?.paciente_id) || pacienteId,
                      agenda: escolha.agenda,
                      orcamento_id: state.orcamento_id ? state.orcamento_id : null,
                      procedimentoId: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).id,
                      procedimento: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).label || null,
                      procedimento_id: opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId).id,
                      valor: valor_cobrado,
                      valor_assinante: (() => {
                        const proc = opcoesProcedimentos.find((p) => p.id === procedimentoSelecionadoId);
                        return proc ? proc.deovita : updatedState.price;
                      })(),
                    };

                    navigate('/atendimento/pedido', {
                      state: states,
                    });
                  } else {
                    // Não logado: salva pedido_pendente e leva ao login/cadastro
                    if (escolha) {
                      setUser((prevState) => ({ ...prevState, pedido_pendente: { ...escolha, agenda: escolha.agenda, valor: valor_cobrado } }));
                    }
                    navigate('/login');
                  }
                }}
                disabled={user.loggedIn === true ? !disabled : false}
                color={'white'}
              >
                Agendar Consulta
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Formik>
      <BottomNavBar />
    </>
  ) : (
    <>
      {user.loggedIn === true ? <ChildHeader /> : <NoUserHeader />}
      <VStack w={{ base: '100%' }} pt="15%" justify="center">
        <div style={{ backgroundColor: '#B6C1BF', borderRadius: '50%' }}>
          <Image src={SadIcon} h="12em" />
        </div>
        <Heading textAlign="center" color="#5AB2AE" mt="2em" fontSize={24}>
          Oops...
        </Heading>
        <Heading textAlign="center" fontWeight={200} color="#585858" mt="2em" fontSize={18}>
          Estamos sem horários disponíveis<br></br>para o esse médico. Tente<br></br>novamente mais tarde
        </Heading>
      </VStack>
    </>
  );
}

export default Agendamento;
